import {FC, useEffect, useMemo} from 'react'
import {useSelector} from 'react-redux'
import {useLocation} from 'react-router'
import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {authSelector} from 'src/redux/slices/authSlices'
import {
  notificationSelector,
  setAmount,
  setUnreadNotifications,
} from 'src/redux/slices/notificationSlices'
import {fetchNotificationAmount} from 'src/services/fetcher'
import styled from 'styled-components'

const StyledAmount = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  background-color: red;
  border: 1.5px solid white;
  color: white;
  font-size: 10px;
  font-weight: 600;
  position: absolute;
  top: 12px;
  right: -6px;
  width: 20px;
  height: 20px;
`

type Prop = {
  _key: number
}

export const NotificationAmount : FC<Prop> = ({
  _key
}) => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const {amount} = useAppSelector(notificationSelector)
  const {credential} = useSelector(authSelector)

  /** Should be true if the amount value greater than 99  */
  const isMaxAmount = useMemo(() => amount > 99, [amount])

  /** Defining dynamic width of StyledAmount based on isMaxAmount value */
  const width = useMemo(() => (isMaxAmount ? '30px' : '20px'), [amount])

  /** Text to be displayed based on isMaxAmount value */
  const text = useMemo(() => {
    const totalAmount = isMaxAmount ? 99 : amount
    const suffix = isMaxAmount ? '+' : ''
    return `${totalAmount}${suffix}`
  }, [amount])

  /** Request to the server for getting notification total */
  const handleFetchNotificationAmount = () => {
    if (!credential) return

    fetchNotificationAmount({credential})
      .then((res) => {
        dispatch(setAmount(res.data.data.total))
        dispatch(setUnreadNotifications(res.data.data.notifs))
      })
      .catch((err) => {
      })
  }

  /** Invoke the handler while credential or location changes */
  useEffect(() => {
    handleFetchNotificationAmount()
  }, [credential, location, _key])

  if (amount === 0) return null

  return <StyledAmount style={{width: width}}>{text}</StyledAmount>
}
